import { useQuery } from '@tanstack/react-query';

import { pageSectionsQuery } from './pageSectionsQuery';

export const usePageSections = (pageKey: string) => useQuery(pageSectionsQuery(pageKey));
